import { Injectable } from '@angular/core';

export type ValueLike = number|string|null|undefined

@Injectable({
  providedIn: 'root'
})
export class RoundService {

  private _roundType: 'number' | 'zero' = 'zero'   // TODO взять из дневника

  get roundType() {
    return this._roundType
  }

  getApproxSymbol(n: number) {
    if (n < 0.005 && n > -0.005 && n != 0) {
      switch (this._roundType) {
        case 'zero':
          return '≈'
        case 'number':
          return n > 0 ? '<' : '>'
      }
    }
    return ''
  }

  getApproxValue(n: number) {
    if (n < 0.005 && n > -0.005 && n != 0) {
      switch (this._roundType) {
        case 'zero':
          return 0
        case 'number':
          return n > 0 ? 0.01 : -0.01
      }
    }
    return Math.round(n * 100) / 100
  }

  getSignSymbol(n: number, forcePlus = false) {
    if (n < 0) {
      if (n > -0.005) {
        switch (this._roundType) {
          case 'zero':
            return ''
          case 'number':
            return '-'
        }
      }
      return '-'
    }
    else if (n > 0 && forcePlus) {
      if (n < 0.005) {
        switch (this._roundType) {
          case 'zero':
            return ''
          case 'number':
            return '+'
        }
      }
      return '+'
    }
    return ''
  }

  getCurrencyFormat(n: number) {
    const cent = Math.round(Math.abs(n) * 100) - Math.floor(Math.abs(n)) * 100
    return cent == 0 ? '1.0-0' : '1.2-2'
  }

  getCents(n: number) {
    return Math.round(Math.abs(n) * 100) - Math.floor(Math.abs(n)) * 100
  }

  transformToNumber(n: ValueLike): number | null {
    if (typeof(n) == 'number') {
      return n
    }
    if (typeof(n) == 'string') {
      const n2 = parseFloat(n)
      if (!isNaN(n2) && isFinite(n2)) {
        return n2
      }
    }
    return null
  }
}
